import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@emburse/embark-core';
import PdfViewer from '../../../components/PdfViewer';
import AgreementFooter from './AgreementFooter';
import AgreementHeader from './AgreementHeader';
const msaHref = 'https://cdn.certify.com/forte/CSG%20Forte-Merchant%20Services%20Agreement.pdf';
const headerHeight = 110;
function MerchantServiceAgreement({ onCheckboxToggled }) {
    return (_jsxs(Stack, { sx: {
            display: 'flex',
            flexDirection: 'column',
            height: `calc(70vh - ${headerHeight}px)`,
            width: '100%',
            overflow: 'hidden',
            backgroundColor: '#f9f9f9'
        }, children: [_jsx(Stack, { sx: { width: '100%' }, children: _jsx(AgreementHeader, { file: msaHref }) }), _jsx(Stack, { sx: {
                    flex: 1,
                    overflow: 'auto',
                    minHeight: 0,
                    width: '100%'
                }, children: _jsx(PdfViewer, { file: msaHref, sx: {
                        width: '100%',
                        height: '100%'
                    } }) }), _jsx(Stack, { sx: { width: '100%' }, children: _jsx(AgreementFooter, { onCheckboxToggled: onCheckboxToggled }) })] }));
}
MerchantServiceAgreement.defaultProps = {
    onCheckboxToggled: () => { }
};
export default MerchantServiceAgreement;
